import { render } from "./SavedToSpendBalance.vue?vue&type=template&id=7e7a33ae&scoped=true"
import script from "./SavedToSpendBalance.vue?vue&type=script&lang=js"
export * from "./SavedToSpendBalance.vue?vue&type=script&lang=js"

import "./SavedToSpendBalance.vue?vue&type=style&index=0&id=7e7a33ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7a33ae"]])

export default __exports__